
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Contexto } from '../modelo/contexto';
import { SegurancaService } from '../service/seguranca.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-entidades',
  templateUrl: './entidades.html'
})
export class EntidadesComponent implements OnInit{

    constructor(
        private segurancaService: SegurancaService,
        private route: ActivatedRoute,
        private router: Router 
      ) { }

    //https://vishalwaman.medium.com/storing-encryptions-keys-in-angular-vuejs-reactjs-cee6c5306a5e
    //https://dev.to/zokizuan/mastering-secure-local-storage-in-angular-with-crypto-js-k8a
    ngOnInit() {
        let contextoBase64 = this.route.snapshot.params.contexto;
        //console.log('contextoBase64: '+contextoBase64);
        if(contextoBase64){
          let contextoString = atob(contextoBase64);
          if(contextoString){
            const contextoArray = contextoString.split(',');
            //const database = '29';
            //const entity = '32';
            const database = contextoArray[0].split(':');
            const entity = contextoArray[1].split(':');

            //Salvando o contexto sem a URL do Cliente
            //this.saveContexto(new Contexto('', database,entity));
            this.saveContexto(new Contexto('', database[1],entity[1]));

            // Login para o contexto selecionado
            const tokenBetha = this.segurancaService.getWebToken()?.access_token;
            if(tokenBetha && this.segurancaService.isAuthenticated()){
              this.segurancaService.loginQuasarProxy().subscribe({
                next: (data: any) => { 
                  if (data) {
                    // Salvar os dados do login na Quasar
                    if (data.listaObj) {
                      let webTokenQuasar = this.segurancaService.getWebToken();
                      webTokenQuasar.wsLoginQuasar = data.listaObj[0];
                      localStorage.setItem('token', JSON.stringify(webTokenQuasar));
                    } else if (data.errorRest) {
                      throw Error(data.errorRest.message);
                    }
                  }
                },
                error: (err) => {
                  // se der erro no login, NÃO segue para getUrlAppCliente
                  console.error('Erro no loginQuasarProxy:', err);
                },
                complete: () => {
                  // Recuperar a URL do sistema Quasar do cliente (só após terminar o login)
                  this.segurancaService.getUrlAppCliente().subscribe({
                    next: (data: any) => {
                      if (data && data.listaObj) {
                        // Salvar o contexto com a URL do Cliente
                        this.saveContexto(new Contexto(data.listaObj[0], database[1], entity[1]));
                        this.goToHome();
                      } else {
                        throw Error('Sistema não configurado para o contexto selecionado!');
                      }
                    },
                    error: (err) => {
                      console.error('Erro ao obter URL do cliente:', err);
                    }
                  });
                }
              });
            }else{
              this.sendToLoginBetha();
            }
          }
        }
    }


    saveContexto(contexto: Contexto) {
      const data = JSON.stringify(contexto);
  
      //localStorage -> Persiste no browser do usuario
      //sessionStorage -> Fechou a aba do browser os dados sao perdidos
      //Salvar como json para possibilitar salvar vários objetos
      //console.log(data);
      localStorage.setItem('contexto', data);
    }


    goToHome() {
      //console.log('EntidadesComponent.isAuthenticated: '+this.segurancaService.isAuthenticated());
      if(!this.segurancaService.isAuthenticated()){
        //Login
        this.sendToLoginBetha();
      }else if(this.segurancaService.isAuthenticatedQuasar() && this.segurancaService.isLicencaSelecionada() && this.segurancaService.getLicenca().redirectArbor){
        this.sendToApp();
      }else{
        //Home
        this.router.navigate([''], { relativeTo: this.route }) .then(() => {
          window.location.reload();
        });
      }
    }


    public sendToLoginBetha(){
      this.segurancaService.sendToLoginBetha();
    }

    public sendToApp(){
      this.segurancaService.sendToApp();
    }
}


